import React from 'react';
import PageTitle from '../elements/PageTitle';
import ArticleBody from '../elements/ArticleBody';
import ArticleContainer from '../elements/ArticleContainer';
import BackLink from '../components/core/BackLink';
import SponsorLink from '../components/articles/SponsorLink';
import Layout from '../components/core/Layout';

export default () => (
  <Layout>
    <ArticleContainer>
      <PageTitle>The Albukhary Foundation Gallery of the Islamic world</PageTitle>
      <BackLink text="Back" />
      <ArticleBody>
        <p>
          The Albukhary Foundation is a non-profit organisation based in Malaysia with an
          international presence. For the past forty years, it has been promoting goodwill through
          education and cultural heritage. The Foundation’s many initiatives have been guided by the
          values of compassion, tolerance, and coexistence with the objective of helping to shape a
          more equitable and tolerant world, In improving the lives of less privileged communities,
          the Foundation has spearheaded extensive humanitarian projects, widening educational
          opportunities, as well as promoting scholarship amongst Muslims and non-Muslims alike.
        </p>
        <p>
          The Albukhary Foundation’s key role on the cultural front is reflected in its
          establishment of, and ceaseless support for, the Islamic Arts Museum Malaysia. An esteemed
          cultural institution in the heart of Kuala Lumpur, the museum is now the largest in Asia
          Pacific dedicated to the arts, culture and heritage of the Islamic world.
        </p>
        <p>
          Success in Malaysia has spurred the Foundation to expand its remit further. Besides its
          unwavering commitment to the areas of education, social welfare and religion, the intent
          to bridge further understanding between cultures and faiths also makes up much of the
          Albukhary Foundation’s international activity. This initiative continues in the Albukhary
          Foundation Gallery of the Islamic World.
        </p>
      </ArticleBody>
      <SponsorLink />
    </ArticleContainer>
  </Layout>
);
